import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  signal,
  untracked,
  inject,
} from '@angular/core';
import { NetworkAvailabilityHandlerService } from '../services/network-availability-handler.service';
import { DOCUMENT, JsonPipe } from '@angular/common';
import { AuthService, User } from '@auth0/auth0-angular';
import { take } from 'rxjs';
import { AppConfigService } from 'src/app/shared/app-config/app-config.service';
import { MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'ri-resolution-ui-network-availability-dialog',
  imports: [JsonPipe, MatDialogTitle, MatDialogContent],
  templateUrl: './network-availability-dialog.component.html',
  styleUrl: './network-availability-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkAvailabilityDialogComponent {
  private readonly networkAvailabilityHandlerService = inject(
    NetworkAvailabilityHandlerService
  );
  private readonly authService = inject(AuthService);
  private readonly appConfigService = inject(AppConfigService);
  private readonly document = inject<Document>(DOCUMENT);

  readonly visible = signal<boolean>(false);

  readonly userData = signal<User | null>(null);
  readonly userAgent = this.document.defaultView?.navigator.userAgent || '';
  readonly utcDate = signal<string>('');
  readonly reportIssueUrl = this.appConfigService.config.reportIssueUrl;

  readonly errors = this.networkAvailabilityHandlerService.errorSignal;

  private readonly hasError = computed(() => {
    return this.errors().length > 0;
  });

  constructor() {
    this.trackApiAvailabilityError();
  }

  private trackApiAvailabilityError(): void {
    effect(() => {
      const hasError = this.hasError();

      untracked(() => {
        this.authService.user$.pipe(take(1)).subscribe((user) => {
          this.userData.set(user || null);
        });

        this.utcDate.set(new Date().toUTCString());
        this.visible.set(hasError);
      });
    });
  }
}
